import Vue from 'vue' ;
import {Component} from 'vue-property-decorator' ;
import {namespace} from 'vuex-class' ;
import {CrudStatus} from '../../../../common/enums';
import {USER_INFO_FIELD, USER_MODULE_NAMESPACE} from '../../../../store/user/user-types.store';
import {IUser} from '../../../../models/user/user.model';
import {IUserDetails} from '../../../../models/user';

const UserStore = namespace(USER_MODULE_NAMESPACE)

@Component
class ProfileModalVertical extends Vue {

  dtCurrentSignature: string

  @UserStore.Getter userCrudActionStatus: CrudStatus
  @UserStore.Getter user: IUser
  @UserStore.Getter userInfo: IUserDetails

  @UserStore.Mutation(USER_INFO_FIELD)
  storeSetUserInfo;

  constructor() {
    super()
    this.dtCurrentSignature = null
  }

  mounted() {
    this.dtCurrentSignature = this.userInfo.signature
  }

  get signature() {
    return this.userInfo.signature
  }
  set signature(params) {
    this.storeSetUserInfo({ signature: params })
  }

  get lblSetting() {
    return {
      ...require('@/locales/profile').default,
      ...require('@/locales/validation-messages').default,
      ...require('@/locales/generic-labels').default
    }
  }

  handleClearSignature() {
    if (this.dtCurrentSignature) {
      this.dtCurrentSignature = "";
    } else {
      (this.$refs.signaturePad as any).clearSignature();
    }
    this.$emit('change-signature', null)
  }
  handleUndo() {
    (this.$refs.signaturePad as any).undoSignature();
    setTimeout(this.onEnd, 200)
  }
  onEnd() {
    const { data, isEmpty } = (this.$refs.signaturePad as any).saveSignature()
    if (!isEmpty) {
      // this.signature = data;
      this.$emit('change-signature', data)
    } else {
      this.$emit('change-signature', null)
    }
  }
}

export default ProfileModalVertical



// WEBPACK FOOTER //
// ./src/containers/profile/components/profile-signature-modal-vertical/index.ts